import { JSONable } from '@irian-ro/abstract-resource';

export class PackageStateModel extends JSONable {
  canDownloadLabelPdf: boolean | undefined = undefined;
  canMarkAsLost: boolean | undefined = undefined;
}
